import Header from './components/Header/Header';
import DrumMachine from './components/DrumMachine/DrumMachine';
import Footer from './components/Footer/Footer';
import './App.css';

function App() {
  return (
    <div className="App">
      <Header />
      <DrumMachine />
      <Footer />
    </div>
  );
}

export default App;
